/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Images
import productImage from "assets/images/products/product-11.jpg";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../../../../../store/notification/notification-slice";
import MDBadge from "../../../../../../components/MDBadge";
import Box from "@mui/material/Box";
import {Tooltip} from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";

function QRCard({ cover }) {
  const [copiedText, setCopiedText] = useState();

  return (
    <Card>
        <MDBox pt={2} px={2} lineHeight={1}>
            <MDTypography variant="h6" fontWeight="medium">
                QR Code
            </MDTypography>
        </MDBox>
      <MDBox
        position="relative"
        borderRadius="lg"
        mt={2}
        mx={2}
        className="card-header"
        sx={{ transition: "transform 300ms cubic-bezier(0.34, 1.61, 0.7, 1)" }}
      >
        <MDBox
          component="img"
          src={cover}
          alt="Event QR Code"
          borderRadius="lg"
          shadow="sm"
          width="50%"
          height="50%"
          position="relative"
        />
        <CopyToClipboard
            text={cover}
            onCopy={() => setCopiedText(cover)}
        >
        <Tooltip
            title={
              copiedText === cover
                  ? "This was Copied!"
                  : "Copy To Clipboard"
            }
            placement="top"
        >
          <Box
              component="button"
              fontFamily="inherit"
              fontSize="16px"
              fontWeight="400"
              lineHeight="1.25"
              display="inline-block"
              width="100%"
              margin=".5rem 0"
              padding="24px"
              textAlign="left"
              border="0"
              borderRadius="4px"
              data-clipboard-text="album-2"
              type="button"
          >
            <div>
              <i className="ni ni-active-40" />
              <span>{cover}</span>
            </div>
          </Box>
        </Tooltip>
        </CopyToClipboard>
      </MDBox>
    </Card>
  );
}

export default QRCard;
